import React from "react";

export default function dataExchange({ color = "white" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17">
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.39 11.638c-.628 0-1.194.244-1.623.636L4.882 8.842c.045-.186.074-.38.074-.578 0-.198-.029-.392-.074-.578l5.823-3.4a2.46 2.46 0 0 0 1.685.67 2.48 2.48 0 0 0 2.478-2.478A2.48 2.48 0 0 0 12.39 0a2.48 2.48 0 0 0-2.478 2.478c0 .198.029.392.074.578l-5.823 3.4a2.46 2.46 0 0 0-1.685-.67A2.48 2.48 0 0 0 0 8.264a2.48 2.48 0 0 0 2.478 2.478 2.46 2.46 0 0 0 1.685-.669l5.885 3.432a2.338 2.338 0 0 0-.066.541 2.408 2.408 0 1 0 2.408-2.408"
      />
    </svg>
  );
}
